// src/utils/currencyUtils.js

export const formatToPHP = (amount) => {
    return amount != null
        ? new Intl.NumberFormat('en-PH', {
            style: 'currency',
            currency: 'PHP',
        }).format(amount)
        : "N/A";
};
